import { createRouter, createWebHistory } from 'vue-router';
import {
	contactsListRoute,
	packageConfigureRoute,
	projectsListRoute,
	projectsViewRoute,
	welcomeRoute,
} from '@/router/routes';

export {
	contactsListRoute,
	packageConfigureRoute,
	projectsListRoute,
	projectsViewRoute,
	welcomeRoute,
} from '@/router/routes';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		projectsViewRoute,
		projectsListRoute,
		contactsListRoute,
		welcomeRoute,
		packageConfigureRoute,

		// route level code-splitting
		// this generates a separate chunk (About.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		// component: () => import('../pages/AboutView.vue'),
	],
});

router.afterEach((to, from) => {
	if (from.path == '/' || from.fullPath == to.fullPath) {
		return;
	}
	window.dispatchEvent(new CustomEvent('scoro-base-amplitude-page-view'));
});

export default router;
